import React from "react";
import { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import "./sticker.css";
import Button from "react-bootstrap/Button";
import swal from "sweetalert";

const Sticker = () => {
  const [data, setData] = useState([]);
  const [record, setRecord] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [showData, setShowData] = useState(false);

  const [receivedStatusByRow, setReceivedStatusByRow] = useState({});

  useEffect(() => {
    Axios.get("http://13.200.156.92:5000/getOrder").then((response) => {
      setData(response.data);
    });
  }, []);

  const handleClose = () => {
    setShowData(false);
  };

  const handleButtonClick = (item) => {
    setRecord(item.updatedQuantity);
    setSelectedOrderId(item.orderid);
    setShowData(true);
  };

  const handleSaveClick = async (selectedRow) => {
    try {
      const selectedStatus = receivedStatusByRow[selectedRow.orderid];

      if (!selectedStatus || selectedStatus === "Select Received Status") {
       alert("Please select 'Yes' or 'No' for Received Status.");
        return;
      }

      const payload = {
        Receivedstatus: selectedStatus,
      };

      await Axios.put(
        `http://13.200.156.92:5000/updateReceivedStatus/${selectedRow._id}`,
        payload
      );

      swal({
        title: "Data updated successfully",
        text: "",
        icon: "success",
      });
      window.location.reload();
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Error updating data. Please try again.");
    }
  };

  return (
    <div className="stickermain">
      <label>
        <h3>Sticker Records</h3>
      </label>

      <div>
        <div>
          <Table responsive className="stickertable">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Order-Date</th>
                <th>Vehicle No & Dispatch-Date</th>
                <th>Title</th>
                <th>Medium</th>
                <th>Edition</th>
                <th>SKU</th>
                <th>Sticker Records</th>
                <th>Quantity</th>
                <th>Received Status</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <React.Fragment key={row.orderid}>
                  {row.updatedQuantity.map((item, index) => (
                    <tr key={index}>
                      {index === 0 && (
                        <>
                          <td>{row.orderid}</td>
                          <td>
                            {new Date(row.ApprovalDate).toLocaleDateString(
                              "en-US",
                              {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              }
                            )}
                          </td>

                          <td>{row.status}</td>
                          <td>
                            {row.updatedQuantity
                              .map((item) => item.title)
                              .map((title, index) => (
                                <React.Fragment key={index}>
                                  {title}
                                  <br />
                                </React.Fragment>
                              ))}
                          </td>
                          <td>
                            {row.updatedQuantity
                              .map((item) => item.Medium)
                              .map((Medium, index) => (
                                <React.Fragment key={index}>
                                  {Medium}
                                  <br />
                                </React.Fragment>
                              ))}
                          </td>
                          <td>
                            {row.updatedQuantity
                              .map((item) => item.edition)
                              .map((edition, index) => (
                                <React.Fragment key={index}>
                                  {edition}
                                  <br />
                                </React.Fragment>
                              ))}
                          </td>
                          <td>
                            {row.updatedQuantity
                              .map((item) => item.sku)
                              .map((sku, index) => (
                                <React.Fragment key={index}>
                                  {sku}
                                  <br />
                                </React.Fragment>
                              ))}
                          </td>
                          <td>
                            {index === 0 && (
                              <Button
                                onClick={() => handleButtonClick(row)}
                                disabled={
                                  showData && selectedOrderId === row.orderid
                                }
                              >
                                Sticker Records <i className="fas fa-eye"></i>
                              </Button>
                            )}
                          </td>

                          <td>
                            {row.updatedQuantity
                              .map((item) => item.quantity)
                              .map((quantity, index) => (
                                <React.Fragment key={index}>
                                  {quantity}
                                  <br />
                                </React.Fragment>
                              ))}
                          </td>

                          <td>
                            <select
                              value={
                                receivedStatusByRow[row.orderid] ||
                                "Select Received Status"
                              }
                              onChange={(e) =>
                                setReceivedStatusByRow((prevStatus) => {
                                  return {
                                    ...prevStatus,
                                    [row.orderid]: e.target.value,
                                  };
                                })
                              }
                            >
                              <option disabled>Select Received Status</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>

                          <td
                            className={
                              row.Receivedstatus === "Yes"
                                ? "received-yes"
                                : "received-no"
                            }
                          >
                            {row.Receivedstatus}
                          </td>

                          <td>
                            <Button onClick={() => handleSaveClick(row)}>
                              Update
                            </Button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      {showData && (
        <div>
          <Table striped>
            <Button
              type="button"
              className="SerialNumberbtn"
              onClick={handleClose}
            >
              Close
            </Button>
            <thead>
              <tr>
                <td>BatchID</td>
                <td>Title</td>
                <td>Serial Number</td>
              </tr>
            </thead>
            <tbody>
              {record.map((row, index) =>
                Array.from(Array(row.approvedquantity), (_, serialIndex) => (
                  <tr key={serialIndex}>
                    <td>{row.batchid}</td>
                    <td>{row.title}</td>
                    <td>
                      {row.batchid}-{serialIndex + 1}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default Sticker;
